import { RouterProvider } from 'react-router-dom';
import { Monitoring } from '@/shared/lib';
import { appRouter } from '../../model/appRouter';

export function Router() {
  return <RouterProvider router={appRouter(Monitoring.createBrowserRouter)} />;
}
